export default "__VITE_ASSET__BZFkOjaH__"